import actions from './actions';
import { keyBy } from '../../../../../helpers/core';
import { createReducer } from '../../../../../helpers/reducer';

const initState = {
  talents: null,
  loading: false,
  total: 0,
  selectedTalent: null,
  isConversionCalculatorModalOpen: false,
  editConversionCalculatorForm: null,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal } = payload;
  const talents = data;

  return {
    ...state,
    talents,
    total,
    filteredTotal,
    loading: false,
  };
}

function onAdd(state) {
  return {
    ...state,
    loading: true,
  };
}

function onAddSuccess(state) {
  return {
    ...state,
    loading: false,
  };
}

function onToggleConversionCalculatorModal(state, { payload }) {
  return {
    ...state,
    isConversionCalculatorModalOpen: payload,
  };
}

function onLoadConversionCalculatorDataSuccess(state, { payload }) {
  const { data } = payload;
  const conversion_hours = data.threshold - data.current_hours_worked;
  const conversion_fee = conversion_hours * data.average_bill_rate;
  const calculatedData = {
    conversion_hours: conversion_hours > 0 ? conversion_hours : 0,
    conversion_fee: conversion_fee > 0 ? conversion_fee : 0,
  };
  const conversionCalculatorData = { ...data, ...calculatedData };

  const propsArray = Object.keys(conversionCalculatorData);

  const editConversionCalculatorForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: conversionCalculatorData[prop],
      error: false,
      touched: false,
    }),
  );

  return {
    ...state,
    editConversionCalculatorForm,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editConversionCalculatorForm } = state;

  editConversionCalculatorForm[attr] = {
    value,
    error: false,
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editConversionCalculatorForm: {
      ...editConversionCalculatorForm,
    },
  };
}

function onClearConversionCalculatorForm(state) {
  return { ...state, editConversionCalculatorForm: null };
}

function onSetSelectedTalent(state, { payload }) {
  return {
    ...state,
    selectedTalent: payload,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.ADD]: onAdd,
  [actions.ADD_SUCCESS]: onAddSuccess,
  [actions.LOAD_CONVERSION_CALCULATOR_DATA_SUCCESS]: onLoadConversionCalculatorDataSuccess,
  [actions.TOGGLE_CONVERSION_CALCULATOR_MODAL]: onToggleConversionCalculatorModal,
  [actions.CONVERSION_CALCULATOR_CHANGE_PROPERTY]: onChangeProperty,
  [actions.CLEAR_CONVERSION_CALCULATOR_FORM]: onClearConversionCalculatorForm,
  [actions.SET_SELECTED_TALENT]: onSetSelectedTalent,
  [actions.CLEAR_STORE]: onClearStore,
});
